import NPawPlugin from 'npaw-plugin';
import { appConfig } from '../config/app.config';
let npawPluginInstance: NPawPlugin | null = null;
/**
 * Initialize NPawPlugin instance based on the app configuration
 * If cdnBalancerEnabled is true, create a new instance with balancer component
 * Otherwise, create an instance with balancer component disabled
 */
if (appConfig.cdnBalancerEnabled) {
    npawPluginInstance = new NPawPlugin(appConfig.cdnBalancerAccountCode);
} else {
    npawPluginInstance = new NPawPlugin(appConfig.cdnBalancerAccountCode, {
        components: {
            balancer: false,
        },
    });
}

export default npawPluginInstance;
